/**
 * @file テキストボックスに入力されたら、targetを活性化する
 */
'use strict'

/**
 * @classname InputActivation
 * @classdesc テキストボックスに入力されたらtargetを活性化する
 */
export default class InputActivation {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.file_name')
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`)
		this._$e = $e
		this._$trigger = this._$e.find('[data-input-activation-type="trigger"]')
		this._$target = this._$e.find('[data-input-activation-type="target"]')
		this._$trigger.on('change', () => this.onChange())
	}

	/**
	 * onChangeのコールバック
	 *
	 * @memberof InputActivation
	 * @return {undefined}
	 */
	onChange() {
		console.log(`${this.constructor.name}.onChange :: value`, this._$trigger.val());
		const isInputted = this._$trigger.val();
		if (isInputted && isInputted !== '') {
			this._$target.each((index, item) => {
				$(item).prop('disabled', false)
			})
		} else {
			this._$target.each((index, item) => {
				$(item).prop('disabled', true)
			})
		}
	}
}
